import { BoardValue } from '../../jscaip/AI/BoardValue';
import { Heuristic } from '../../jscaip/AI/Heuristic';
import { Ordinal } from '../../jscaip/Ordinal';
import { Player } from '../../jscaip/Player';
export class EpaminondasPositionalHeuristic extends Heuristic {
    getBoardValue(node, _config) {
        return BoardValue.of(this.getPieceCountThenSupportThenAdvancement(node.gameState));
    }
    getPieceCountThenSupportThenAdvancement(state) {
        const width = state.getWidth();
        const height = state.getHeight();
        const MAX_ADVANCEMENT_SCORE_TOTAL = 28 * width;
        const SCORE_BY_ALIGNMENT = MAX_ADVANCEMENT_SCORE_TOTAL + 1; // OLDLY 13
        const MAX_NUMBER_OF_ALIGNMENT = (24 * 16) + (4 * 15);
        const SCORE_BY_PIECE = (MAX_NUMBER_OF_ALIGNMENT * SCORE_BY_ALIGNMENT) + 1; // OLDLY 25*13
        let total = 0;
        for (const coordAndContent of state.getPlayerCoordsAndContent()) {
            const coord = coordAndContent.coord;
            const player = coordAndContent.content;
            let avancement; // between 0 and 11
            let dirs;
            if (player === Player.ZERO) {
                avancement = height - coord.y;
                dirs = [Ordinal.UP_LEFT, Ordinal.UP, Ordinal.UP_RIGHT];
            }
            else {
                avancement = coord.y + 1;
                dirs = [Ordinal.DOWN_LEFT, Ordinal.DOWN, Ordinal.DOWN_RIGHT];
            }
            const mod = player.getScoreModifier();
            total += avancement * mod;
            total += SCORE_BY_PIECE * mod;
            for (const dir of dirs) {
                let neighbor = coord.getNext(dir, 1);
                while (state.hasPieceAt(neighbor, player)) {
                    total += mod * SCORE_BY_ALIGNMENT;
                    neighbor = neighbor.getNext(dir, 1);
                }
            }
        }
        return total;
    }
}
